import { render, staticRenderFns } from "./tableFinancialHighlights.vue?vue&type=template&id=1cdaed52&scoped=true"
import script from "./tableFinancialHighlights.vue?vue&type=script&lang=js"
export * from "./tableFinancialHighlights.vue?vue&type=script&lang=js"
import style0 from "./tableFinancialHighlights.vue?vue&type=style&index=0&id=1cdaed52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdaed52",
  null
  
)

export default component.exports